module.exports = __webpack_public_path__ + "c7a610793a788ef0aca7ebf3050b89a7.pdf";